// extracted by mini-css-extract-plugin
export default {"links-container":"LinksList_links-container__5BkxA"};